import React from "react";
import "./AudioCallPopups.css";
import { FaVideo } from "react-icons/fa";

const VideoCallOutgoingPopups = ({ visible, title = "Calling...", subTitle = "", onCancel }) => {
    if (!visible) return null;

    return (
        <div className="audio-call-overlay">
            <div className="audio-call-card">
                <div className="audio-call-avatar"><FaVideo style={{ fontSize: 26 }} /></div>
                <h3>{title}</h3>
                {subTitle ? <p>{subTitle}</p> : null}

                <div className="audio-call-actions">
                    <button className="audio-btn end" onClick={onCancel}>
                        End
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VideoCallOutgoingPopups;